import * as commonLayoutRoutes from "./common"
import * as paLayoutRoutes from "./admin"


// Combined routes
export default Object.assign({}, commonLayoutRoutes, paLayoutRoutes)
